<template>
  <div>
    <Navbar/>
    <slot />
    <Footers />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Footers from "@/components/Footer";

export default {
  components: {Footers, Navbar}
}
</script>
